// extracted by mini-css-extract-plugin
module.exports = {"card":"ItemCard_card__3c4-S","img_container":"ItemCard_img_container__2g6eT","info":"ItemCard_info__3e4hW"};